import { Card, CardBody } from '@chakra-ui/react';
import { useState } from 'react';

import { DealStateEnum } from '../../../../utils/types/deal';
import { DealWithFarthestState, POST_SIGNING_STATES } from '../../utils';
import DashboardUploadDocuments from '../documents/DashboardUploadDocuments';
import PreSigningDocumentsCard from './PreSigningDocumentsCard';
import PostSigningDocumentsCard from './postSigningStepper/PostSigningDocumentsCard';
import type { PriorityDoc } from './utils';

export type UploadingTarget = {
  doc?: PriorityDoc;
  isCobuyer: boolean;
};

type Props = {
  deal: DealWithFarthestState;
};

const StepperDocumentsCard = ({ deal }: Props) => {
  const [uploadingTarget, setUploadingTarget] = useState<UploadingTarget | null>(null);
  const isPostSigning = POST_SIGNING_STATES.includes(deal?.farthestState as DealStateEnum);

  if (uploadingTarget !== null) {
    return (
      <Card borderRadius="24px" p={2}>
        <CardBody>
          <DashboardUploadDocuments
            deal={deal}
            setUploadDocuments={() => setUploadingTarget(null)}
            priorityDoc={uploadingTarget.doc}
            isCobuyer={uploadingTarget.isCobuyer}
          />
        </CardBody>
      </Card>
    );
  }

  if (isPostSigning) {
    return <PostSigningDocumentsCard deal={deal} onUpload={setUploadingTarget} />;
  }

  return <PreSigningDocumentsCard deal={deal} onUpload={setUploadingTarget} />;
};

export default StepperDocumentsCard;
